import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ShipmentWaybillCommentsService } from './shipment-waybill-comments.service';
import { Injectable } from '@angular/core';
import { NotificationService } from '../../../../../common/services';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { ShipmentCommentsModel } from '../../../../models';
import {
  ShipmentWaybillCommentsInitialState,
  ShipmentWaybillCommentsLoad,
  ShipmentWaybillCommentsSave,
} from './shipment-waybill-comments.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentWaybillCommentsStateModel {
  comments: ShipmentCommentsModel[];
  loaded: boolean;
}

const initialState: ShipmentWaybillCommentsStateModel = {
  comments: null,
  loaded: false,
};

@State<ShipmentWaybillCommentsStateModel>({
  name: 'shipmentWaybillComments',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillCommentsState {
  constructor(
    private shipmentWaybillCommentsService: ShipmentWaybillCommentsService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getComments(state: ShipmentWaybillCommentsStateModel): ShipmentCommentsModel[] {
    return state.comments;
  }

  @Selector()
  static getLoaded(state: ShipmentWaybillCommentsStateModel): boolean {
    return state.loaded;
  }

  @Action(ShipmentWaybillCommentsLoad)
  getWaybillComments(
    ctx: StateContext<ShipmentWaybillCommentsStateModel>,
    { payload }: ShipmentWaybillCommentsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillCommentsService.getShipmentWaybillComments(payload).pipe(
      map((comments: ShipmentCommentsModel[]) => {
        ctx.patchState({ comments, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillCommentsSave)
  saveWaybillComment(
    ctx: StateContext<ShipmentWaybillCommentsStateModel>,
    { payload }: ShipmentWaybillCommentsSave,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillCommentsService.saveShipmentWaybillComment(payload.waybill, payload.comment).pipe(
      map((comment: ShipmentCommentsModel) => {
        ctx.patchState({ comments: [...ctx.getState().comments, comment], loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillCommentsInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillCommentsStateModel>): void {
    ctx.setState(initialState);
  }
}
